import get from 'lodash/get';

import { ProductServiceModule } from 'services/data/products.service';
import { AppSettingsModule } from 'services/settings.provider';
import { SubscriptionServiceModule } from './subscription/subscription.service';

export const LimitationsService = angular
    .module('app.services.access.limitations', [
        SubscriptionServiceModule,
        ProductServiceModule,
        AppSettingsModule
    ]).service('limitationsService', (
        subscriptionsService,
        productService,
        $q
    ) => {
        return {
            getProductLimitations,
            getUpdatedProductLimitations,
            isFeatureEnabled
        };

        function getProductLimitations() {
            let getSubscription = subscriptionsService.getSubscription();
            let getProductCount = productService.getProductCount();
            return $q.all([getSubscription, getProductCount]).then(([subscription, productCount]) => {
                return {
                    hasHitProductLimit: productCount >= subscription.features.productLimit,
                    productLimit: subscription.features.productLimit,
                    planId: subscription.plan.id,
                    productCount
                };
            });
        }

        function getUpdatedProductLimitations(featureLimitation, planId, productCount) {
            return {
                hasHitProductLimit: productCount >= featureLimitation.productLimit,
                productLimit: featureLimitation.productLimit,
                planId,
                productCount
            };
        }

        function isFeatureEnabled(featureName) {
            return subscriptionsService.getSubscription()
                .then(subscription => get(subscription.features, featureName, false));
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/access/limitations.service.js